export default __webpack_public_path__ + "static/media/Sanitare.d6a3a861.svg";